var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { BaseComponent } from '../base/base.component';
import { BaseService } from '../base/base.service';
var FooterComponent = /** @class */ (function (_super) {
    __extends(FooterComponent, _super);
    function FooterComponent(router, route, logger, message, page, service) {
        var _this = _super.call(this, router, route, logger, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        return _this;
    }
    FooterComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    FooterComponent.prototype.onMsg = function (msg) {
        this.label = msg['FooterComponent.label.copyright'];
        this.label = this.label.replace(/\{\{year\}\}/, new Date().getFullYear().toString());
    };
    FooterComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'pa-footer',
                    template: "<footer class=\"footer\">\n  <p>\n    <small class=\"copyright\" [innerHTML]=\"label\"></small>\n  </p>\n</footer>\n"
                }] }
    ];
    /** @nocollapse */
    FooterComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: MessageService },
        { type: PageService },
        { type: BaseService }
    ]; };
    return FooterComponent;
}(BaseComponent));
export { FooterComponent };
//# sourceMappingURL=footer.component.js.map